export default __webpack_public_path__ + "static/multi-ai-dark-b62393eed832ddd0b41d2b9283078321.png";